export default "__VITE_ASSET__c3609db7__"